
<template>
  <el-form-item :label="params.label" v-if="params.label">
    <el-input size="small" :type="params.component" :rows="params.rows" :class="params.className" v-model="value" :placeholder="params.placeholder"></el-input>
  </el-form-item>
  <el-input v-else :type="params.component" size="small" v-model="value" :placeholder="params.placeholder"></el-input>
</template>

<script>
export default {
  name: 'v-input',
  props: {
    params: {
      type: Object
    }
  },
  data() {
    return {
      value: ''
    }
  },
  created() {
    this.value = this.params.value
  },
  methods: {
    reset() {
      if (this.params.dValue) {
        this.value = this.params.dValue
      } else {
        this.value = undefined
      }
    },
    getValue() {
      if (this.value) {
        return {
          [this.params.key]: this.value
        }
      }
      return undefined
    }
  },
  watch: {
    value(nv, ov) {
      const cp = JSON.parse(JSON.stringify(this.params))
      cp.value = nv
      this.$emit('csi', cp)
    }
  }
}
</script>

